import { APPOINTMENT_STATUSES } from 'features/order-tracker/utils/entries';

export const compensationLink = 'https://business.bt.com/compensation-scheme/';

export const CompensationLinks = [
  APPOINTMENT_STATUSES.CustomerMissed,
  APPOINTMENT_STATUSES.SupplierMissed,
  APPOINTMENT_STATUSES.SupplierDelayed,
];
